module.exports = __webpack_public_path__ + "img/ice.800aabc1.svg";